import { render, staticRenderFns } from "./TrafficDelayList.vue?vue&type=template&id=7648a005"
import script from "./TrafficDelayList.vue?vue&type=script&lang=js"
export * from "./TrafficDelayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports